import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-10" }

import Icon from "@/components/Icons/Icon.vue";
import ButtonFixed from "@/components/custom/ButtonFixed.vue";
import { ref, computed, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { filesService } from "@/api/services/file";


export default /*@__PURE__*/_defineComponent({
  __name: 'DocumentUpload',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const errors = ref(null);
const loading = ref(false);
const titleField = ref(null);
const fileField = ref(null);

const formState = ref({
  title: "",
  description: "",
  file: null as File | null,
});

const disableSave = computed(() => {
  return !formState.value.title || !formState.value.file;
});

const onSubmit = async () => {
  if (loading.value || disableSave.value) return;

  loading.value = true;
  const formData = new FormData();
  formData.append("title", formState.value.title);
  formData.append("description", formState.value.description);
  if (formState.value.file) {
    formData.append("file", formState.value.file);
  }

  try {
    await filesService.store(formData);
    router.replace({ name: "document-documents" });
  } catch (error: any) {
    errors.value = error.response?.data?.errors;
  } finally {
    loading.value = false;
  }
};

const goBack = () => {
  return route.params.page === "files-activity"
    ? router.push({ name: "documents" })
    : router.push({ name: "document-documents" });
};

onMounted(() => {
  // Validate field manually on mount
  titleField.value?.validate();
  fileField.value?.validate();
});

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_container, { class: "px-0 pt-0 pb-5" }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "text-right px-4 pt-3",
          onClick: goBack
        }, [
          _createVNode(Icon, {
            color: "primaryColor",
            icon: "cross-icon"
          })
        ]),
        _createElementVNode("section", _hoisted_1, [
          _createVNode(_component_v_card, { class: "mb-6 pa-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_form, {
                onSubmit: _withModifiers(onSubmit, ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            ref_key: "titleField",
                            ref: titleField,
                            modelValue: formState.value.title,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formState.value.title) = $event)),
                            "error-messages": errors.value?.title,
                            variant: "outlined",
                            rules: [(value) => !!value || 'Required']
                          }, {
                            label: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                              _createTextVNode(" Document Title ", -1),
                              _createElementVNode("span", { style: {"color":"red"} }, "*", -1)
                            ]))]),
                            _: 1
                          }, 8, ["modelValue", "error-messages", "rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_textarea, {
                            modelValue: formState.value.description,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formState.value.description) = $event)),
                            "error-messages": errors.value?.description,
                            label: "Description",
                            variant: "outlined",
                            rows: "3"
                          }, null, 8, ["modelValue", "error-messages"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_file_input, {
                            ref_key: "fileField",
                            ref: fileField,
                            modelValue: formState.value.file,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formState.value.file) = $event)),
                            "error-messages": errors.value?.file,
                            variant: "outlined",
                            accept: ".pdf,.doc,.docx,.txt,.jpg,.jpeg,.png",
                            "show-size": "",
                            rules: [(value) => !!value || 'Required']
                          }, {
                            label: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                              _createTextVNode(" Select Document ", -1),
                              _createElementVNode("span", { style: {"color":"red"} }, "*", -1)
                            ]))]),
                            _: 1
                          }, 8, ["modelValue", "error-messages", "rules"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createElementVNode("section", null, [
      _createVNode(ButtonFixed, {
        "custom-class": [
        'text-white',
        {
          'primary-button': !disableSave.value,
          'grey-disable': disableSave.value || loading.value,
        },
      ],
        "custom-icon-class": "add-new-circle-icon",
        text: "Upload",
        onClick: onSubmit
      }, null, 8, ["custom-class"])
    ])
  ], 64))
}
}

})